module.exports = ".leaving-input {\n  outline: none;\n  resize: none;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal.scss
// module id = ./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal.scss
// module chunks = 0